import React, { useEffect, useState } from 'react';

import { config } from '../../lib/config';
import t from '../../locations/translations';
import { RouteRule } from '../../routes/RouteManager';

const CookieBanner = () => {
	const [visible, setVisible] = useState<boolean>(localStorage.getItem(config.COOKIE_CONSENT) == undefined);

	useEffect(() => {
		const saved = localStorage.getItem(config.COOKIE_CONSENT);
		if (!saved) {
			setVisible(true);
		}
	}, []);

	const acceptCookies = () => {
		localStorage.setItem(config.COOKIE_CONSENT, 'accepted');
		setVisible(false);
	};

	if (!visible) return <></>;

	return (
		<div
			style={{
				position: 'fixed',
				bottom: '20px',
				left: '50%',
				transform: 'translateX(-50%)',
				background: '#ffffff',
				padding: '20px 28px',
				borderRadius: '12px',
				boxShadow: '0px 6px 20px rgba(0,0,0,0.08)',
				display: 'flex',
				alignItems: 'center',
				gap: '20px',
				maxWidth: '600px',
				width: '90%',
				zIndex: 9999,
			}}
		>
			<div style={{ fontSize: '40px', color: '#3b82f6' }}>🍪</div>

			<div style={{ flex: 1, fontSize: '14px', color: '#333' }}>
				{t('cookie_consent')}{' '}
				<a href={RouteRule.privacyPolicy.path} style={{ color: '#3b82f6', textDecoration: 'underline' }}>
					Zistiť viac
				</a>
			</div>

			<button
				onClick={acceptCookies}
				style={{
					background: '#0f172a',
					color: 'white',
					padding: '10px 20px',
					borderRadius: '8px',
					border: 'none',
					cursor: 'pointer',
					fontSize: '14px',
				}}
			>
				Súhlasim
			</button>
		</div>
	);
};

export default CookieBanner;
